import { Box, Image, Media, Optional, ToastNotification, Toaster, useMediaQueries, } from '@honda-canada/design-system-react';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Sticky from 'react-stickynode';
import { useTranslation } from 'react-i18next';
import ConfigurationProvider from './service/Provider';
import { INVENTORY_CALCULATOR } from '../TrimPayment/constants';
import LeavingModal from '../LeavingModal';
import Price from './Price';
import PriceError from '../PriceComponent/Error';
import SaveBuild from '../SaveBuild';
import SaveBuildModal from '../SaveBuild/SaveBuildModal';
import TrimAssets from './TrimAssets';
import TrimDetails from './TrimDetails';
import themeStyles from './TrimOverview.styles';
import useBapNavigationBlock from '../ProgressBar/hooks/useBapNavigationBlock';
import useSaveBuildModal from '../SaveBuild/useSaveBuildModal';
const TrimOverviewContainer = themeStyles.apply(Box, 'TrimOverviewContainer');
const TrimInfoWrapper = themeStyles.apply(Box, 'TrimInfoWrapper');
const TrimInfoBadgeWrapper = themeStyles.apply(Box, 'TrimInfoBadgeWrapper');
const ModelBadge = themeStyles.apply(Image, 'ModelBadge');
export const TrimOverviewUI = ({ trim, isFetchingAssets, removeToastNotificationHandler, nameBadge, componentName, stickToComponentDesktop, stickToComponentMobile, showPrice, showPriceError, showSaveBuild, toastNotifications, trimAssetsProps, isInventoryVariant, paymentData, pageTitle, }) => {
    const { t } = useTranslation();
    const { isMobile } = useMediaQueries();
    const [stickToComponentHeight, setStickToComponentHeight] = useState(0);
    const { nextUrl, showLeaveModal, showSaveBuildModal, closeModal } = useBapNavigationBlock(showSaveBuild);
    const { handleCloseModal, ...saveBuildModalProps } = useSaveBuildModal({
        closeModal,
        componentName,
        isExitConfirmationModal: true,
        nextUrl,
    });
    const { modelYear, trimName, transmissionKey, transmissionName } = trim;
    const priceErrorStyles = {
        container: {
            display: ['flex', 'none'],
            height: 'auto',
            mt: 'xs',
        },
    };
    // Interior uses the first exterior image as a placeholder,
    // therefore it gets the same styling as exterior in that case
    const hasExteriorAsset = trimAssetsProps.isExterior || trimAssetsProps.showPlaceholder;
    useEffect(() => {
        var _a, _b, _c;
        const stickToComponentComponentName = isMobile ? stickToComponentMobile : stickToComponentDesktop;
        const element = document.getElementById(stickToComponentComponentName || '');
        const height = isMobile
            ? ((_a = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().height) !== null && _a !== void 0 ? _a : 0) + ((_b = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top) !== null && _b !== void 0 ? _b : 0)
            : (_c = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().height) !== null && _c !== void 0 ? _c : 0;
        setStickToComponentHeight(height);
    }, [isMobile, stickToComponentDesktop, stickToComponentMobile]);
    const price = isInventoryVariant ? (React.createElement(Price, { paymentData: paymentData, shouldFetchPayment: false, calculatorId: INVENTORY_CALCULATOR })) : (React.createElement(Price, null));
    return transmissionKey ? (React.createElement(React.Fragment, null,
        React.createElement(Optional, { when: pageTitle },
            React.createElement(Helmet, null,
                React.createElement("title", null, pageTitle))),
        React.createElement(Sticky, { top: stickToComponentHeight, enabled: !!stickToComponentHeight, bottomBoundary: "#sidebar-layout-wrapper" },
            React.createElement(TrimOverviewContainer, { isExterior: hasExteriorAsset, "data-component-name": componentName, "data-testid": "cy-trim-overview", height: isFetchingAssets ? ['311px', '311px', '608px'] : undefined },
                React.createElement(TrimInfoWrapper, { isExterior: hasExteriorAsset },
                    React.createElement(TrimInfoBadgeWrapper, { hasPriceError: showPriceError },
                        React.createElement(ModelBadge, { "data-testid": "cy-model-badge", src: nameBadge === null || nameBadge === void 0 ? void 0 : nameBadge.src, alt: nameBadge === null || nameBadge === void 0 ? void 0 : nameBadge.alt }),
                        React.createElement(Optional, { when: showPriceError },
                            React.createElement(PriceError, { message: t('Pages.Models.Exploration.contactLocalDealerLabel'), verticalAlignment: "center", errorIconName: "exclamationAlert", errorStyles: priceErrorStyles }))),
                    React.createElement(Optional, { when: modelYear && trimName && transmissionName },
                        React.createElement(TrimDetails, { transmissionName: transmissionName, modelYear: modelYear, trimName: trimName, size: "payment" })),
                    React.createElement(Optional, { when: showPrice }, price),
                    React.createElement(Optional, { when: showSaveBuild },
                        React.createElement(SaveBuild, { componentName: componentName }))),
                React.createElement(TrimAssets, { ...trimAssetsProps, isInventoryVariant: isInventoryVariant }),
                React.createElement(Media, { greaterThan: "smallDesktop" },
                    React.createElement(Toaster, { style: { bottom: '50px', left: '30px', zIndex: 9999 } }, toastNotifications === null || toastNotifications === void 0 ? void 0 : toastNotifications.map(({ id, message, ...others }) => (React.createElement(ToastNotification, { id: id, key: id, displayDurationMs: 5000, onDisplayDurationComplete: () => {
                            removeToastNotificationHandler(id);
                        }, ...others }, message))))))),
        React.createElement(Optional, { when: showSaveBuild },
            React.createElement(LeavingModal, { nextUrl: nextUrl, showModal: showLeaveModal, closeModal: closeModal }),
            React.createElement(SaveBuildModal, { showModal: showSaveBuildModal, handleCrossIconClick: handleCloseModal, handleCloseModal: () => {
                    SaveBuild.navigateTo(nextUrl);
                    handleCloseModal();
                }, ...saveBuildModalProps })))) : null;
};
const TrimOverview = ({ appNameConfig, ...restProps }) => (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
    React.createElement(TrimOverviewUI, { ...restProps })));
export default TrimOverview;
